"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@material-ui/core/styles");
const moment = require("moment");
const React = require("react");
const CustomToolbar = ({ date, setOpenView }) => {
    const theme = (0, styles_1.useTheme)();
    const dialogRef = React.useRef(null);
    const classes = useStyles(theme);
    React.useEffect(() => {
        setTimeout(() => {
            var _a;
            (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 10);
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.root }, { children: [(0, jsx_runtime_1.jsx)("span", { "aria-label": "Select a date of birth", role: "dialog", autoFocus: true, tabIndex: 0, ref: dialogRef, className: classes.hiddenSpan, "aria-hidden": true }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("button", Object.assign({ className: `MuiButtonBase-root MuiButton-root MuiButton-text MuiPickersToolbarButton-toolbarBtn ${classes.localToolbarBtnOverride} ${classes.yearButton}`, onClick: () => setOpenView('year'), "aria-label": `${moment(date).format('YYYY')}, Change year` }, { children: moment(date).format('YYYY') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.monthText }, { children: moment(date).format('ddd, MMM DD') }))] })] })));
};
exports.default = CustomToolbar;
const useStyles = (0, styles_1.makeStyles)((theme) => ({
    root: {
        background: theme.palette.primary.main,
        color: theme.palette.common.white,
        minHeight: 56,
        padding: '0 24px',
        height: 100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start'
    },
    hiddenSpan: {
        position: 'absolute',
        width: '1px',
        height: '1px',
        padding: 0,
        margin: '-1px',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        border: 'none',
        outline: 'none',
        top: 0,
        left: 0
    },
    yearButton: {
        color: theme.palette.common.white,
        padding: 0,
        borderBottom: `1px solid ${theme.palette.common.white}`,
        minWidth: 'auto',
        paddingRight: 15,
        fontFamily: 'Montserrat-Medium'
    },
    monthText: {
        margin: 0,
        fontSize: '18px',
        fontFamily: 'Montserrat-Bold',
        fontWeight: 400,
        lineHeight: '26px',
        letterSpacing: 0
    },
    localToolbarBtnOverride: {
        position: 'relative',
        paddingRight: 15,
        borderRadius: 0,
        '&::after': {
            content: '""',
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            width: 0,
            height: 0,
            borderLeft: '5px solid transparent',
            borderRight: '5px solid transparent',
            borderTop: `5px solid ${theme.palette.common.white}`,
            pointerEvents: 'none'
        }
    }
}));
//# sourceMappingURL=CustomToolbar.js.map